// extracted by mini-css-extract-plugin
export default {"input":"M_-z","button":"N_-z","selected":"O_-z","unavailable":"P_-z","oos":"Q_-z","image":"R_-z","paperCutDisabledOverlay":"S_-z"};